export interface FaqItem {
  id: number;
  titleKey: string;
  descKey: string;
}

const faqData: FaqItem[] = [
  {
    id: 1,
    titleKey: "faq_q_token_sale_support",
    descKey: "faq_a_token_sale_support",
  },
  {
    id: 2,
    titleKey: "faq_q_startup_selection",
    descKey: "faq_a_startup_selection",
  },
  {
    id: 3,
    titleKey: "faq_q_contribution_flow",
    descKey: "faq_a_contribution_flow",
  },
  {
    id: 4,
    titleKey: "faq_q_risk_transparency",
    descKey: "faq_a_risk_transparency",
  },
  {
    id: 5,
    titleKey: "faq_q_affiliate_rewards",
    descKey: "faq_a_affiliate_rewards",
  },
  {
    id: 6,
    titleKey: "faq_q_research",
    descKey: "faq_a_research",
  },
];

export default faqData;
